import { fetchAuthSession } from "aws-amplify/auth";
import { post, put } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { TODOS_QUERY_KEY } from "./useTodosQuery";

export const useTodosPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "todosapi",
        path: "/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TODOS_QUERY_KEY] });
    },
  });
};

export const useTodosPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "todosapi",
        path: "/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TODOS_QUERY_KEY] });
    },
  });
};
